import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "label", "tabIndex", "value", "tag", "to", "href", "target", "rel", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useContext } from 'react';
import TabsContext from '../../Tabs/TabsContext';
export var useTab = function useTab(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      label = _ref.label,
      tabIndex = _ref.tabIndex,
      value = _ref.value,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      to = _ref.to,
      href = _ref.href,
      target = _ref.target,
      rel = _ref.rel,
      onClick = _ref.onClick,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(TabsContext),
      currentlyActiveTab = _useContext.currentlyActiveTab,
      wide = _useContext.wide,
      handleClick = _useContext.handleClick;

  var matchingContentViewValue = typeof value !== 'undefined' ? value : tabIndex;
  var isActive = currentlyActiveTab === tabIndex;
  var handleSelect = useCallback(function (event) {
    if (handleClick) {
      handleClick(event, tabIndex, matchingContentViewValue);
    }

    if (onClick) {
      onClick(event);
    }
  }, [handleClick, tabIndex, matchingContentViewValue]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: ref,
      wide: wide,
      disabled: disabled,
      isActive: isActive,
      onClick: handleSelect
    }),
    tabLabelContainerProps: {
      disabled: disabled
    },
    tagProps: {
      to: to,
      href: href,
      target: target,
      rel: rel
    },
    tabLabelProps: {
      disabled: disabled,
      isActive: isActive,
      wide: wide
    },
    disabled: disabled,
    isActive: isActive,
    Tag: Tag,
    label: label,
    children: children
  };
};